import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import Table from "../../../ui/Table";
import TableFormatter, {
  EditDeleteFormatter,
} from "../../../ui/TableFormatter";
import Modal from "../../../ui/Modal";
import AddOrganisationForm from "./AddOrganisationForm";
import { GetHook } from "../../../api/api";
import {
  COMPANY_URL,
  ORGANISATION_TYPE_URL,
  ORGANISATION_URL,
  USER_URL,
} from "../../../api/urls";
import axios from "../../../utils/axios";
import { useLocation } from "react-router-dom";
import { get } from "../../../utils/get";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { parseDropdown } from "../../../utils/parseDropdown";
import useDebounce from "../../../utils/useDebounce";

const OrganisationSettings = () => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [handleSubmit, setHandleSubmit] = useState();
  const [editData, setEditData] = useState({});
  const [edit, setEdit] = useState(false);
  const [organisations, setOrganisations] = useState([]);
  const [filter, setFilter] = useState({});
  const { data, error, pending, reload } = GetHook(ORGANISATION_URL);
  const { data: managers } = GetHook(`${USER_URL}?limit=1000`);
  const { data: types } = GetHook(ORGANISATION_TYPE_URL);
  const { data: companies } = GetHook(COMPANY_URL);
  const [filteredOrgs, setFilteredOrgs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [dataSize, setDataSize] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [results, setResults] = useState([]);

   const { availableResultSet } = GetHook(
    `${ORGANISATION_URL}?limit=1`
  );

  const location = useLocation();

  useEffect(() => {
    setOrganisations(data);
    return () => {};
  }, [data]);

  useEffect(() => {
    if (
      get(filter, "orgType") &&
      get(filter, "parent") &&
      get(filter, "company")
    ) {
      axios
        .get(
          `${ORGANISATION_URL}?${get(filter, "orgType")}&${get(
            filter,
            "parent"
          )}&${get(filter, "company")}`
        )
        .then((res) => {
          const { returned_resultset } = get(res, "data");
          setOrganisations(returned_resultset);
        });
    } else if (get(filter, "orgType") && get(filter, "parent")) {
      axios
        .get(
          `${ORGANISATION_URL}?${get(filter, "orgType")}&${get(
            filter,
            "parent"
          )}`
        )
        .then((res) => {
          const { returned_resultset } = get(res, "data");
          setOrganisations(returned_resultset);
        });
    } else if (get(filter, "orgType") && get(filter, "company")) {
      axios
        .get(
          `${ORGANISATION_URL}?${get(filter, "orgType")}&${get(
            filter,
            "company"
          )}`
        )
        .then((res) => {
          const { returned_resultset } = get(res, "data");
          setOrganisations(returned_resultset);
        });
    } else if (get(filter, "company") && get(filter, "parent")) {
      axios
        .get(
          `${ORGANISATION_URL}?${get(filter, "company")}&${get(
            filter,
            "parent"
          )}`
        )
        .then((res) => {
          const { returned_resultset } = get(res, "data");
          setOrganisations(returned_resultset);
        });
    } else if (get(filter, "manager")) {
      axios.get(`${ORGANISATION_URL}?${get(filter, "manager")}`).then((res) => {
        const { returned_resultset } = get(res, "data");
        setOrganisations(returned_resultset);
      });
    } else if (get(filter, "company")) {
      axios.get(`${ORGANISATION_URL}?${get(filter, "company")}`).then((res) => {
        const { returned_resultset } = get(res, "data");
        setOrganisations(returned_resultset);
      });
    } else if (get(filter, "orgType")) {
      axios.get(`${ORGANISATION_URL}?${get(filter, "orgType")}`).then((res) => {
        const { returned_resultset } = get(res, "data");
        setOrganisations(returned_resultset);
      });
    } else if (get(filter, "parent")) {
      axios.get(`${ORGANISATION_URL}?${get(filter, "parent")}`).then((res) => {
        const { returned_resultset } = get(res, "data");
        setOrganisations(returned_resultset);
      });
    } else {
      setOrganisations(data);
    }
    return () => {};
  }, [filter]);

  const handleEdit: any = (row: any) => {
    setisModalOpen(true);
    setEdit(true);
    setEditData(row);
  };

  const handleDelete = (id: string) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          axios
            .delete(`${ORGANISATION_URL}/${id}`)
            .then((res) => {
              setOrganisations(
                organisations.filter((org: any) => org.id != id)
              );
              toast.success("Organisation has been deleted");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error(error.response.data.message));
        }
      }
    });
  };

  const closeModal = () => {
    setisModalOpen(false);
    setEdit(false);
    setEditData({});
    reload(get(location, "key"));
  };
  

  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  useEffect(() => {
    // Make sure we have a value (user has entered something in input)
    if (debouncedSearchTerm) {
      // Set isSearching state
      setIsSearching(true);
      // Fire off our API call
      axios.get(`${ORGANISATION_URL}?name=${debouncedSearchTerm}`).then((res) => {
        // Set back to false since request finished
        setIsSearching(false);
        // Set results state
        setFilteredOrgs(res?.data?.returned_resultset);
        setDataSize(res?.data.available_resultset_size);
        setPageCount(Math.ceil(res?.data.available_resultset_size / 10));
      });
    } else {
      setResults([]);
    }
  }, [debouncedSearchTerm]);

  const handleSearch = (e) => {
    if (e?.target.value) {
      setSearchTerm(e.target.value);
      setFilter({ company: "", manager: "" , orgType: "" , parent: "" });
    } else {
      setFilteredOrgs([]);
      setDataSize(0);
      setPageCount(Math.ceil(availableResultSet / 10));
      console.log({ searchTerm });
    }
  };

  const columns = [
    {
      Header: "Organization Name",
      accessor: "name",
    },
    {
      Header: "Manager",
      accessor: "manager",
      Cell: ({ row }: any) => (
        <TableFormatter
          name={row.original.manager.names}
          url={row.original.url}
        />
      ),
    },
    {
      Header: "Organisation Type",
      accessor: "organisation_type.name",
    },
    {
      Header: "Under",
      accessor: "parent_organisation.name",
    },
    {
      id: "1",
      Header: "",
      Cell: ({ row }: any) => (
        <EditDeleteFormatter
          showEdit={() => handleEdit(row.original)}
          handleDelete={() => handleDelete(row.original.id)}
        />
      ),
    },
  ];
  return (
    <OrganisationContainer>
      <HeaderContainer>
        <TitleText>Organization</TitleText>
      </HeaderContainer>
      <Table
        data={filteredOrgs.length ? filteredOrgs : organisations}
        columns={columns}
        dataSize={dataSize ? dataSize : availableResultSet}
        handleSearch={handleSearch}
        isOrganisation
        setModal={setisModalOpen}
        pageCount={pageCount}
        setFilter={setFilter}
        //TODO filter if manager
        owners={parseDropdown(managers)}
        companies={parseDropdown(companies)}
        filter={filter}
        organisations={parseDropdown(data)}
        orgTypes={parseDropdown(types)}
      />
      {isModalOpen && (
        <Modal
          title={edit ? "Edit organisation" : "Add new Organisation"}
          handleSubmit={handleSubmit}
          closeModal={closeModal}
        >
          <AddOrganisationForm
            closeModal={closeModal}
            setHandleSubmit={setHandleSubmit}
            editData={editData}
            organisations={organisations}
            setOrganisations={setOrganisations}
          />
        </Modal>
      )}
    </OrganisationContainer>
  );
};

export default OrganisationSettings;

const OrganisationContainer = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
  background-color: #fff;
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
`;
